import { Card } from "antd";
import React from "react";

interface StoryCardProps {
    story: string;
    title:string;
}

const StoryCard: React.FC<StoryCardProps> = ({ story, title }) => {
    return (
        <Card
            className="section"
            title={title}
            style={{
                maxWidth: '850px',
                margin: "0 auto",
                lineHeight: "2",
                marginBottom: "32px"
            }}
        >
            {story.trim().split('\n').map((line, index) => (
                <div key={index} style={{ marginBottom: '10px' }}>{line}</div>
            ))}
        </Card>
    );
};

export default StoryCard;
